module.exports = __webpack_public_path__ + "static/media/Abhay-Pandey.2c1145d2.png";